<template>
  <div>

    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <h1 class="bannerTitle">{{ $t('section.title') }}</h1>
        <p class="bannerSubtitle">{{ $t('section.subtitle') }}</p>
      </div>
    </section>

    <!--Info section-->
    <section class="bg sectionPad">
      <v-row class="gridpad">
        <v-col cols="12" lg="6" class="txt-j d-flex align-center justify-start">
          <div>
            <p class="historyText mb-6">En 1958, Bisson Service se donnait le mandat de régler <strong>tous les soucis</strong> de ses clients en ce qui a trait à leur eau potable. Depuis plus de 60 ans, cette mission est encore bien présente et à votre service.</p>
            <div class="d-flex py-2">
              <img class="iconSize" src="/Resources/images/icon/location.png"/>
              <p class="join" v-html="$t('section.address')"></p>
            </div>
            <div class="d-flex py-2">
              <img class="iconSize" src="/Resources/images/icon/phone.png"/>
              <a class="phone" href="tel:819-472-7904" v-html="$t('section.phone')"></a>
            </div>
            <div class="d-flex py-2">
              <img class="iconSize" src="/Resources/images/icon/mail.png"/>
              <a href="mailto:info@bissonservice.com"><p class="linkMail" v-html="$t('section.mail')"></p></a>
            </div>
            <div class="d-flex mt-4 gap-4">
              <p @click="openCookie()" class="cookieLink">Mes témoins</p>
              <p @click="navigateToPolicy()" class="cookieLink">Politique de confidentialité</p>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j d-flex align-center justify-lg-end justify-start">
          <div>
            <p v-html="$t('section.dateNumber')"></p>
            <p class="mt-4">Pour nos services d'urgence :
              <a class="phone" href="tel:819-472-7904" v-html="$t('section.phone')"></a>
            </p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Formulaire contact-->
    <section class="bgForm gridpadForm sectionPad">
      <v-row>
        <v-col><h2 class="pumpSectionTitle mb-6">Nous contacter</h2></v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <form ref="form">
            <v-row>
              <v-col>
                <v-row>
                  <v-col class="fieldMin">
                    <v-row class="padForm">
                      <p class="bold f-secondary" v-if="!error.name" style="font-size: 14px;">Nom:</p>
                      <p class="bold error" v-if="error.name" style="font-size: 14px;">Nom:</p>
                    </v-row>
                    <v-row class="padForm">
                      <v-text-field @change="error.name = false" id="name" name="name" type="text" v-model="item.name" bg-color="blue-lighten-5" clearable required/>
                      <p class="errorText" v-if="error.name" style="font-size: 14px; margin-top: -25px;">** Un nom est requis**</p>
                    </v-row>
                  </v-col>
                  <v-col class="fieldMin">
                    <v-row class="padForm"><p class="bold f-secondary" style="font-size: 14px;">Courriel</p></v-row>
                    <v-row class="padForm">
                      <v-text-field id="Courriel" name="Courriel" type="text" v-model="item.email" bg-color="blue-lighten-5" clearable required/>
                    </v-row>
                  </v-col>
                  <v-col class="fieldMin">
                    <v-row class="padForm"><p class="bold f-secondary" style="font-size: 14px;">Adresse</p></v-row>
                    <v-row class="padForm">
                      <v-text-field id="Ville" name="Ville" type="text" v-model="item.location" bg-color="blue-lighten-5" clearable required/>
                    </v-row>
                  </v-col>
                  <v-col class="fieldMin">
                    <v-row class="padForm">
                      <p class="bold f-secondary" v-if="!error.phone" style="font-size: 14px;">Téléphone</p>
                      <p class="bold error" v-if="error.phone" style="font-size: 14px;">Téléphone</p>
                    </v-row>
                    <v-row class="padForm">
                      <v-text-field id="Telephone" name="Telephone" type="text" label="xxx xxx-xxxx" v-model="item.phone" bg-color="blue-lighten-5" clearable required/>
                      <p class="errorText" v-if="error.phone" style="font-size: 14px; margin-top: -25px;">Un téléphone est requis **</p>
                    </v-row>
                  </v-col>
                  <v-col class="fieldMin">
                    <v-row class="padForm"><p class="bold f-secondary" style="font-size: 14px;">Service voulu</p></v-row>
                    <v-row class="padForm">
                      <v-select id="Problematiques" name="Problematiques" clearable chips v-model="item.problems" bg-color="blue-lighten-5" :items="serviceItems" multiple required/>
                    </v-row>
                  </v-col>
                  <v-col class="fieldFormMax">
                    <v-row class="padForm"><p class="bold f-secondary" style="font-size: 14px;">Description</p></v-row>
                    <v-row class="padForm">
                      <v-textarea clearable required no-resize id="description" name="description" v-model="item.Message" label="Description" bg-color="blue-lighten-5" rows="7" row-height="45" single-line :counter="520" maxlength="520"/>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="d-flex flex-lg-row flex-column">
              <v-col cols="12" lg="6" class="d-flex align-center justify-md-center justify-start">
                <p v-if="Dialog == 'error'" style="color: red; margin-left:15px;">Il y a eu un problème dans la demande, veuillez recommencer</p>
              </v-col>
              <v-col cols="12" lg="6" class="d-flex align-center justify-md-end justify-center">
                <v-btn v-if="Dialog != 'send'" @click="SendForm();" class="button" style="margin-right:15px;">
                  <span class="buttonText2" v-if="Dialog == 'notSend' || Dialog == 'error'">Envoyer</span>
                  <span class="buttonText2" v-if="Dialog == 'pending'">Veuillez patienter...</span>
                </v-btn>
                <h3 id="ContactFormSent" v-if="Dialog == 'send'" class="f-primary" style="text-align: center; font-size: 2em;">La demande a été envoyée !</h3>
              </v-col>
            </v-row>
          </form>
        </v-col>
      </v-row>
    </section>

    <!--Google Maps-->
    <section>
      <iframe class="map" style="border:0; margin-bottom: -4px;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2777.872604134693!2d-72.518639108993!3d45.87385833146289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc813e3b04681df%3A0x2225e244fdb72350!2s924%20Rue%20Saint-Pierre%2C%20Drummondville%2C%20QC%20J2C%204A5!5e0!3m2!1sfr!2sca!4v1691589950088!5m2!1sfr!2sca">
      </iframe>
    </section>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .sectionPad { padding: 50px 0px; }
  .map { width: 100%; height: calc(150px + 20vw); }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../public/Resources/images/Banner/bannerContactUs.jpg');
    background-attachment: fixed;
    background-position: center 65%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  .bannerSubtitle {
    color: rgba(255,255,255,0.85);
    font-size: 18px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Unified Titles*/
  .pumpSectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  /*#endregion*/

  /*#region Info section*/
  .historyText { font-size: 18px; color: rgba(var(--menuColor), 0.7); font-style: italic; border-left: 4px solid rgb(var(--primary)); padding-left: 16px; line-height: 1.7; }
  .gridpad { padding: 0px 200px; }
  .sSlogan { color: rgba(var(--menuColor), 0.8); font-weight: 500; font-size: 22px; padding: 0px 0px 30px 0px; }
  .bg { background-color: rgb(var(--tierce2)); }
  .iconSize { height: 16px; width: 16px; margin: 5px 0px 0px 0px; }
  .join { font-size: 18px; color: rgb(var(--secondary)); font-weight: 700; padding: 0px 0px 0px 10px; }
  .phone { font-size: 18px; color: rgb(var(--secondary)); font-weight: 700; padding: 0px 0px 0px 10px; }
  .phone:hover { color: rgb(var(--primary)); }
  .linkMail { font-size: 18px; color: rgb(var(--secondary)); font-weight: 700; padding: 0px 0px 0px 10px; }
  .linkMail:hover { color: rgb(var(--primary)); }
  .cookieLink { color: rgb(var(--secondary)); text-decoration: none; cursor: pointer; font-size: 16px; }
  .cookieLink:hover { text-decoration: underline !important; color: rgb(var(--primary)); }
  .gap-4 { gap: 16px; }
  /*#endregion*/

  /*#region Form*/
  .gridpadForm { padding: 50px 200px; }
  .bgForm { background-color: rgb(var(--tierce2)); }
  .fieldMin { min-width: 50%; }
  .fieldFormMax { min-width: 100%; }
  .padForm { padding: 5px 10px; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 700px) {
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerTitle { font-size: 22px; }
    .bannerOverlay { padding: 25px 20px; }
    .fieldMin { min-width: 100%; }
    .gridpad { padding: 20px 15px; }
    .gridpadForm { padding: 15px; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .gridpad { padding: 30px !important; }
    .gridpadForm { padding: 10px !important; }
    .sectionPad { padding: 30px 0px; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .gridpad { padding: 50px 50px; }
    .gridpadForm { padding: 50px 50px; }
    .bg { height: 100%; }
  }
</style>

<script>
  import pageTranslations from '../../public/Resources/i18N/contact.json';

  export default {
    name: 'contact',
    data: () => ({
      parallaxOffset: 0,
      item: {
        name: null,
        email: null,
        phone: null,
        address: null,
        location: null,
        treatment: null,
        problems: null,
        Message: null
      },
      Dialog: 'notSend',
      error: { name: false, phone: false },
      serviceItems: [
        "Traitement d'eau",
        "Entretien et réparation pompe à eau",
        "Réparation de moteurs électriques",
        "Analyse d'eau",
        "Achat d'un produit",
        "Contrôleur à pression constante",
        "Services vacuum"
      ],
    }),
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      navigateToPolicy() { this.$router.push('/politique-de-confidentialite'); },
      openCookie() { this.$emit('openCookie'); },
      validation: async function () {
        let valid = true;
        let errorFlag = { name: false, phone: false };
        if (this.item.name == null || this.item.name.length == 0) { valid = false; errorFlag.name = true; }
        if (this.item.phone == null || this.item.phone.length < 12) { valid = false; errorFlag.phone = true; }
        this.error = errorFlag;
        return valid;
      },
      login: async function () {
        let api = 'https://abstracxion.wx3data.com/security/login/BissonService';
        try {
          let response = await fetch(api, {
            method: 'PUT', mode: 'cors', cache: 'no-cache', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            redirect: 'follow', referrerPolicy: 'no-referrer',
            body: JSON.stringify({ LoginName: '', password: '' })
          });
          if (await response.ok && await response.status !== 204) {
            return await response.text();
          }
        } catch (error) { console.log(error); }
      },
      SendForm: async function () {
        this.Dialog = 'pending';
        let valid = await this.validation();
        if (valid == true) {
          let formData = new FormData(this.$refs.form);
          let api = 'https://abstracxion.wx3data.com/eCommerce/Forms/ContactUs/sendByEmail';
          try {
            let token = await this.login();
            let response = await fetch(api, {
              method: 'POST', mode: 'cors', cache: 'no-cache', credentials: 'same-origin',
              headers: { 'Authorization': 'Bearer ' + token },
              redirect: 'follow', referrerPolicy: 'no-referrer',
              body: formData
            });
            if (await response.ok && await response.status !== 204) {
              this.Dialog = 'send';
            } else { this.Dialog = 'error'; }
          } catch (error) { this.Dialog = 'error'; }
        } else { this.Dialog = 'error'; }
      },
    },
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
    },
    components: {},
  }
</script>